// Generated by ts-to-zod
import { z } from 'zod';

export const engineDuplicatePayloadSchema = z.object({
  name: z.string(),
});
